import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ExchangeRateService } from 'src/app/services/page-service/exchange-rate/exchange-rate.service';
import { BehaviorSubject } from 'rxjs';
import Swal from 'sweetalert2';
import { SharedTools } from 'src/app/shared/shared-tools/shared-tools';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from '../services/util.service';

interface PayoutLocation {
  id: number;
  name: string;
  logo: string;
  type: string;
  locations: number;
}

interface AccountOption {
  id: number;
  name: string;
  logo: string;
  type: string;
  processingTime: string;
}

@Component({
  selector: 'app-remit',
  templateUrl: './remit.component.html',
  styleUrls: ['./remit.component.scss'],
})
export class RemitComponent implements OnInit {
  exchangerate!: any;
  sendamount!: any;
  formSendAmount!: FormGroup;
  rate!: any;
  fees!: any;
  receiveamount!: any;
  currency!: any;
  apiVersion = new BehaviorSubject<string>('0.0.0');
  numberRegEx = /\-?\d*\.?\d{1,2}/;
  isError: boolean = false;

  usformatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2 /* ,
    maximumSignificantDigits: 3 */,
  });

  phformatter = new Intl.NumberFormat('fil-PH', {
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: 2,
  });

  isCurrencyPH: boolean = true;
  isSubmitted: boolean = false;

  private quickExchangeSendMoney = 'QUICK_EXCHANGE_SEND_MONEY';
  private exchangeRate = 'EXCHANGE_RATE';
  steps = [
    {
      number: 1,
      title: 'Sign Up or Login Your Account',
      description:
        'Login to LOGO Mobile App Sign-Up and complete required information for First Time User & Register you device.',
      icon: 'fas fa-user-plus',
    },
    {
      number: 2,
      title: 'Send Amount',
      description: 'Select Send Money Online and Enter Send Amount',
      icon: 'fas fa-money-bill-wave',
    },
    {
      number: 3,
      title: 'Recipient Details',
      description: 'Add or Select Beneficiary Information and Payment Mode.',
      icon: 'fas fa-users',
    },
    {
      number: 4,
      title: 'Confirm Transaction',
      description: 'Review, Confirm and Submit your transaction',
      icon: 'fas fa-check-circle',
    },
  ];

  payoutLocations: PayoutLocation[] = [
    {
      id: 1,
      name: 'M Lhuillier',
      logo: 'assets/images/mlhuillier-logo.png',
      type: 'Pawn Shop',
      locations: 3000,
    },
    {
      id: 2,
      name: 'Cebuana Lhuillier',
      logo: 'assets/images/cebuana-logo.png',
      type: 'Pawn Shop',
      locations: 2500,
    },
    {
      id: 3,
      name: 'LBC',
      logo: 'assets/images/lbc-logo.png',
      type: 'Express Service',
      locations: 7000,
    },
    {
      id: 4,
      name: '7-Eleven',
      logo: 'assets/images/7eleven-logo.png',
      type: 'Convenience Store',
      locations: 2800,
    },
    {
      id: 5,
      name: 'SM Business Centers',
      logo: 'assets/images/sm-logo.png',
      type: 'Mall Service',
      locations: 80,
    },
    {
      id: 6,
      name: 'Robinsons',
      logo: 'assets/images/robinsons-logo.png',
      type: 'Mall Service',
      locations: 60,
    },
  ];

  accountOptions: AccountOption[] = [
    {
      id: 1,
      name: 'BDO',
      logo: 'assets/images/bdo-logo.png',
      type: 'Universal Bank',
      processingTime: '1-2 hours',
    },
    {
      id: 2,
      name: 'BPI',
      logo: 'assets/images/bpi-logo.png',
      type: 'Universal Bank',
      processingTime: '1-2 hours',
    },
    {
      id: 3,
      name: 'Metrobank',
      logo: 'assets/images/metrobank-logo.png',
      type: 'Universal Bank',
      processingTime: '1-2 hours',
    },
    {
      id: 4,
      name: 'UnionBank',
      logo: 'assets/images/unionbank-logo.png',
      type: 'Universal Bank',
      processingTime: '1-2 hours',
    },
    {
      id: 5,
      name: 'GCash',
      logo: 'assets/images/gcash-logo.png',
      type: 'E-Wallet',
      processingTime: 'Instant',
    },
    {
      id: 6,
      name: 'PayMaya',
      logo: 'assets/images/paymaya-logo.png',
      type: 'E-Wallet',
      processingTime: 'Instant',
    },
    {
      id: 7,
      name: 'Coins.ph',
      logo: 'assets/images/coins-logo.png',
      type: 'E-Wallet',
      processingTime: 'Instant',
    },
    {
      id: 8,
      name: 'GrabPay',
      logo: 'assets/images/grabpay-logo.png',
      type: 'E-Wallet',
      processingTime: 'Instant',
    },
  ];

  value!: string;

  isWebMode: boolean = false;
  isMobileMode: boolean = false;
  timerId!: any;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private sharedTools: SharedTools,
    private exchangeRateService: ExchangeRateService,
    private utilService: UtilService
  ) {}

  async ngOnInit(): Promise<void> {
    this.timerId = setInterval(async () => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobileMode = true;
        this.isWebMode = false;
      } else {
        this.isMobileMode = false;
        this.isWebMode = true;
      }
    }, 1);

    this.initForm();

    this.spinner.show();

    this.exchangerate = await this.exchangeRateService
      .loadExchangeRate()
      .toPromise();

    /* .catch((error) =>{
      Swal.fire('Get Exchange Rate.', error.error, 'warning');
      this.spinner.hide();
    }); */

    this.spinner.hide();
    if (this.exchangerate != null && this.exchangerate != undefined) {
      let param = JSON.stringify(this.exchangerate);
      localStorage.setItem(this.exchangeRate, param);

      this.rate = this.exchangerate.Rate != null ? this.exchangerate.Rate : 0;
      this.currency = this.exchangerate.Currency;
      this.fees = this.exchangerate.Fees;
      var receiveCurrency =
        this.exchangerate.SendCurrency != null
          ? this.exchangerate.SendCurrency
          : 'PHP';

      this.sendamount =
        this.formSendAmount.get('inputSendAmount')?.value != null
          ? this.formSendAmount.get('inputSendAmount')?.value
          : 125;
      let sendParse = (parseFloat(this.sendamount) * 100) / 100;

      this.receiveamount = sendParse * this.rate;
      let receiveAmountArray = this.phformatter
        .format(this.receiveamount)
        .split('₱');
      this.formSendAmount
        .get('inputReceiveAmount')
        ?.setValue(receiveAmountArray[1]);
      this.formSendAmount
        .get('selectReceiveCurrency')
        ?.setValue(receiveCurrency);
    }

    this.spinner.hide();
    this.dialog.closeAll();

    //add response for delete and backspace
    addEventListener('keydown', (event: KeyboardEvent) => {
      // Check for allowed keys on keydown
      if (event.key === 'Delete' || event.key === 'Backspace') {
        // Execute your logic here.
        this.onChangeSendAmount(event);
      }
    });
  }

  initForm() {
    this.formSendAmount = new FormGroup({
      inputSendAmount: new FormControl(125.0, [
        Validators.min(25),
        Validators.max(5000),
      ]),
      inputReceiveAmount: new FormControl(0),
      selectSendCurrency: new FormControl('USD'),
      selectReceiveCurrency: new FormControl('PHP'),
    });
    this.formSendAmount.get('selectSendCurrency')?.disable();
  }

  // sendMoney() {
  //   this.isSubmitted = true;
  //   if (this.formSendAmount.valid) {
  //     var inputsend =
  //       this.formSendAmount.get(
  //         'inputSendAmount'
  //       )?.value; /* .replace(/[^0-9.-]+/g, ""); */
  //     this.isError = this.sharedTools.validateAmount(inputsend);
  //     if (this.utilService.isNumeric(inputsend)) {
  //       let paramSendMoney = {
  //         SendAmount: this.formSendAmount.get('inputSendAmount')?.value,
  //         SendCurrency: this.formSendAmount.get('selectSendCurrency')?.value,
  //         ReceiveAmount: this.formSendAmount.get('inputReceiveAmount')?.value,
  //         ReceiveCurrency: this.formSendAmount.get('selectReceiveCurrency')
  //           ?.value,
  //       };
  //       this.utilService.devlog(
  //         'landing paramSendMoney quickExchangeSendMoney',
  //         paramSendMoney
  //       );

  //       let param = JSON.stringify(paramSendMoney);
  //       this.utilService.devlog(
  //         'landing paramSendMoney quickExchangeSendMoney param',
  //         param
  //       );
  //       localStorage.setItem(this.quickExchangeSendMoney, param);
  //       this.router.navigate(['/auth/login'], {
  //         queryParams: { type: 'quick-send', mode: 'login' },
  //       });
  //     } else {
  //       //create swal here "Invalid Input Send Money"
  //       Swal.fire('Information', 'Invalid Send Amount', 'info');
  //     }
  //   }
  // }

  allowNumberOnly(e: any) {
    var returnValue = true;
    const regexpNumber = /[0-9\+\-\ ]/;
    if (
      !(
        (e.keyCode > 95 && e.keyCode < 106) ||
        (e.keyCode > 47 && e.keyCode < 58) ||
        e.keyCode == 8
      )
    ) {
      returnValue = false;
    }
    var value = this.formSendAmount.get('inputSendAmount')?.value.toString();
    if (e.keyCode === 190) {
      if (value.includes('.')) {
        returnValue = false;
      } else {
        returnValue = true;
      }
    }

    return returnValue;
  }

  itemString(e: any) {
    if (this.value.length == 4) {
      return false;
    } else {
      return true;
    }
  }

  onChangeSendAmount(e: any) {
    this.utilService.devlog('onchange - make one time read from api');
    this.value =
      this.formSendAmount.get('inputSendAmount')?.value != null
        ? this.formSendAmount.get('inputSendAmount')?.value.toString()
        : 0;

    let filterExchangeParam = <any>{};
    if (localStorage.getItem(this.exchangeRate) != null) {
      this.utilService.devlog('initialize exchange local storage');
      filterExchangeParam = <any>(
        JSON.parse(localStorage.getItem(this.exchangeRate)!)
      );
      this.exchangerate = filterExchangeParam;
      this.rate = this.exchangerate.Rate;
      this.currency = this.exchangerate.Currency;
      this.fees = this.exchangerate.Fees;

      var receiveCurrency = this.formSendAmount.get(
        'selectReceiveCurrency'
      )?.value;

      this.sendamount =
        this.formSendAmount.get('inputSendAmount')?.value != null
          ? this.formSendAmount.get('inputSendAmount')?.value
          : 0;
      let sendParse = (parseFloat(this.sendamount) * 100) / 100;

      if (receiveCurrency === 'PHP') {
        this.isCurrencyPH = true;
        this.receiveamount =
          this.sendamount == 0 ? 100 * this.rate : sendParse * this.rate;
      } else if (receiveCurrency === 'USD') {
        this.isCurrencyPH = false;
        let value = 1.0;
        this.receiveamount =
          this.sendamount == 0 ? 100 * value : sendParse * value;
      }

      if (sendParse != 0 && sendParse > 0) {
        let receiveAmountArray = this.phformatter
          .format(this.receiveamount)
          .split('₱');
        this.formSendAmount
          .get('inputReceiveAmount')
          ?.setValue(receiveAmountArray[1]);
      } else {
        this.formSendAmount.get('inputReceiveAmount')?.setValue(0);
      }

      //this.spinner.hide();
    }
  }

  changeSendAmountValue() {
    this.spinner.show();
    this.sendamount =
      this.formSendAmount.get('inputSendAmount')?.value != null
        ? this.formSendAmount.get('inputSendAmount')?.value.split(',')
        : 0;
    let sendAmountArray = this.usformatter.format(this.sendamount).split('$');
    this.formSendAmount.get('inputSendAmount')?.setValue(sendAmountArray[1]);
    this.spinner.hide();
    var inputsend = this.formSendAmount
      .get('inputSendAmount')
      ?.value.replace(/[^0-9.-]+/g, '');

    if (inputsend == 0 && inputsend == '' && inputsend == '0.00') {
      this.spinner.hide();
      Swal.fire('Information', 'Invalid input an Send Amount', 'info');
    } else if (!this.utilService.isNumeric(inputsend)) {
      //create swal here "Invalid Input Send Money"
      Swal.fire('Information', 'Invalid input send money', 'info');
    }
  }

  onChangeCurrency(val: any) {
    this.spinner.show();

    this.formSendAmount.get('selectReceiveCurrency')?.setValue(val);
    var receiveCurrency = this.formSendAmount.get(
      'selectReceiveCurrency'
    )?.value;

    this.sendamount =
      this.formSendAmount.get('inputSendAmount')?.value != null
        ? this.formSendAmount.get('inputSendAmount')?.value
        : 0;
    let sendParse = (parseFloat(this.sendamount) * 100) / 100;

    if (receiveCurrency === 'PHP') {
      this.isCurrencyPH = true;
      this.receiveamount = sendParse * this.rate;
    } else if (receiveCurrency === 'USD') {
      this.isCurrencyPH = false;
      let value = 1.0;
      this.receiveamount = sendParse * value;
    }

    if (sendParse != null && sendParse > 0) {
      let receiveAmountArray = this.phformatter
        .format(this.receiveamount)
        .split('₱');
      this.formSendAmount
        .get('inputReceiveAmount')
        ?.setValue(receiveAmountArray[1]);
    } else {
      this.formSendAmount.get('inputReceiveAmount')?.setValue(0);
    }

    this.spinner.hide();
  }

  sendMoney() {
    this.isSubmitted = true;
    if (this.formSendAmount.valid) {
      const inputsend = this.formSendAmount.get('inputSendAmount')?.value;
      this.isError = this.sharedTools.validateAmount(inputsend);

      if (this.utilService.isNumeric(inputsend)) {
        const paramSendMoney = {
          SendAmount: this.formSendAmount.get('inputSendAmount')?.value,
          SendCurrency: this.formSendAmount.get('selectSendCurrency')?.value,
          ReceiveAmount: this.formSendAmount.get('inputReceiveAmount')?.value,
          ReceiveCurrency: this.formSendAmount.get('selectReceiveCurrency')
            ?.value,
        };

        this.utilService.devlog(
          'landing paramSendMoney quickExchangeSendMoney',
          paramSendMoney
        );

        const param = JSON.stringify(paramSendMoney);
        localStorage.setItem(this.quickExchangeSendMoney, param);

        window.location.href =
          'https://logoremit.com/auth/login?type=quick-send&mode=login';
      } else {
        Swal.fire('Information', 'Invalid Send Amount', 'info');
      }
    }
  }
}
